import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Catalog from "@/components/Catalog";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

function Home() {
  return (
    <>
      <Navbar />
      <Hero />
      <Services />
      <Catalog />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </>
  );
}

function TermsAndConditions() {
  return (
    <>
      <Navbar />

      <main className="min-h-screen bg-white text-gray-800">
        <section className="max-w-5xl mx-auto px-6 py-16">
          <h1 className="text-4xl font-bold mb-2">
            Términos y Condiciones
          </h1>

          <h2 className="text-2xl font-semibold mb-8">
            Happy Rental Cancún
          </h2>

          <p className="mb-10 text-lg leading-relaxed">
            Al contratar cualquiera de nuestros servicios, el cliente acepta los
            siguientes términos:
          </p>

          <div className="space-y-8 text-left leading-relaxed">
            <section>
              <h3 className="text-2xl font-semibold mb-3">
                1. Reservaciones
              </h3>
              <p>
                La reservación únicamente quedará confirmada una vez recibido el
                pago correspondiente.
              </p>
              <p className="mt-2">
                Las fechas estarán sujetas a disponibilidad.
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold mb-3">
                2. Pagos
              </h3>
              <p>
                Todos los pagos realizados son definitivos y no son
                reembolsables.
              </p>
              <p className="mt-2">
                En caso de requerirse un cambio de fecha, éste podrá realizarse
                sin costo adicional, sujeto a disponibilidad y siempre que las
                condiciones del hotel o lugar del evento lo permitan.
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold mb-3">
                3. Instalación
              </h3>
              <p>
                Todo el montaje, supervisión y desmontaje será realizado
                exclusivamente por personal autorizado de Happy Rental Cancún.
              </p>
              <p className="mt-2">
                Los clientes no podrán instalar, mover o modificar la ubicación
                del inflable.
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold mb-3">
                4. Supervisión
              </h3>
              <p>
                Los menores deberán permanecer supervisados por un adulto
                responsable en todo momento.
              </p>
              <p className="mt-2">
                Happy Rental Cancún proporciona personal para la operación del
                inflable durante el tiempo contratado, sin sustituir la
                supervisión de padres o responsables.
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold mb-3">
                5. Uso adecuado
              </h3>

              <p className="mb-3">Está prohibido:</p>

              <ul className="list-disc pl-6 space-y-2">
                <li>Utilizar zapatos dentro del inflable.</li>
                <li>Introducir objetos punzocortantes.</li>
                <li>Consumir alimentos o bebidas dentro del inflable.</li>
                <li>Introducir mascotas.</li>
                <li>
                  Manipular motores, conexiones eléctricas o sistemas de
                  inflado.
                </li>
              </ul>
            </section>

            <section>
              <h3 className="text-2xl font-semibold mb-3">
                6. Daños
              </h3>
              <p>
                Cualquier daño ocasionado por uso indebido, negligencia o actos
                intencionales será responsabilidad del cliente.
              </p>
              <p className="mt-2">
                Si el equipo sufriera daños irreparables por causas imputables
                al cliente, éste deberá cubrir el costo de reposición del
                equipo.
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold mb-3">
                7. Condiciones climáticas
              </h3>

              <p className="mb-3">
                Por razones de seguridad, Happy Rental Cancún podrá suspender
                temporal o definitivamente la operación del inflable cuando
                existan condiciones meteorológicas adversas, incluyendo:
              </p>

              <ul className="list-disc pl-6 space-y-2">
                <li>Lluvias intensas.</li>
                <li>Tormentas eléctricas.</li>
                <li>Vientos fuertes.</li>
                <li>
                  Cualquier situación que represente un riesgo para los
                  usuarios.
                </li>
              </ul>
            </section>

            <section>
              <h3 className="text-2xl font-semibold mb-3">
                8. Cancelaciones
              </h3>
              <p>
                Una vez confirmado el servicio mediante pago, no se realizarán
                devoluciones.
              </p>
              <p className="mt-2">
                Cuando sea posible, el cliente podrá solicitar el cambio de
                fecha sujeto a disponibilidad.
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold mb-3">
                9. Limitación de responsabilidad
              </h3>
              <p>
                Happy Rental Cancún no será responsable por accidentes derivados
                del incumplimiento de estas condiciones, del uso inadecuado del
                equipo o de la falta de supervisión de los responsables de los
                menores.
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold mb-3">
                10. Fotografías y contenido
              </h3>
              <p>
                Happy Rental Cancún podrá tomar fotografías o videos de los
                equipos instalados con fines promocionales, procurando no
                identificar a los usuarios sin su consentimiento.
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold mb-3">
                11. Jurisdicción
              </h3>
              <p>
                Cualquier controversia derivada de estos servicios será resuelta
                conforme a las leyes aplicables en el Estado de Quintana Roo,
                México.
              </p>
            </section>
          </div>
        </section>
      </main>

      <Footer />
      <WhatsAppButton />
    </>
  );
}

function PrivacyPolicy() {
  return (
    <>
      <Navbar />

      <main className="min-h-screen bg-white text-gray-800">
        <section className="max-w-5xl mx-auto px-6 py-16">
          <h1 className="text-4xl font-bold mb-2">
            Aviso de Privacidad
          </h1>

          <h2 className="text-2xl font-semibold mb-4">
            Happy Rental Cancún
          </h2>

          <p className="text-gray-500 mb-10">
            Última actualización: Junio 2026
          </p>

          <p className="mb-10 text-lg leading-relaxed">
            En Happy Rental Cancún respetamos su privacidad y protegemos la
            información personal que nos proporciona.
          </p>

          <div className="space-y-8 text-left leading-relaxed">
            <section>
              <h3 className="text-2xl font-semibold mb-3">
                Información que recopilamos
              </h3>

              <p className="mb-3">
                Podemos solicitar la siguiente información:
              </p>

              <ul className="list-disc pl-6 space-y-2">
                <li>Nombre completo.</li>
                <li>Número telefónico.</li>
                <li>Correo electrónico.</li>
                <li>Hotel, domicilio o lugar del evento.</li>
                <li>Fecha y horario del servicio.</li>
                <li>Información necesaria para realizar el pago.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-2xl font-semibold mb-3">
                Uso de la información
              </h3>

              <p className="mb-3">
                La información será utilizada exclusivamente para:
              </p>

              <ul className="list-disc pl-6 space-y-2">
                <li>Elaborar cotizaciones.</li>
                <li>Confirmar reservaciones.</li>
                <li>
                  Coordinar la entrega e instalación de los inflables.
                </li>
                <li>
                  Brindar soporte antes, durante y después del servicio.
                </li>
                <li>
                  Cumplir obligaciones fiscales y administrativas.
                </li>
                <li>
                  Enviar información relacionada con nuestros servicios cuando
                  el cliente lo autorice.
                </li>
              </ul>
            </section>

            <section>
              <h3 className="text-2xl font-semibold mb-3">
                Protección de la información
              </h3>

              <p>
                Implementamos medidas administrativas y tecnológicas para
                proteger sus datos personales y evitar su uso no autorizado.
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold mb-3">
                Compartición de información
              </h3>

              <p className="mb-3">
                No vendemos ni comercializamos datos personales.
              </p>

              <p className="mb-3">
                Únicamente podrán compartirse cuando sea necesario para:
              </p>

              <ul className="list-disc pl-6 space-y-2">
                <li>Procesamiento de pagos.</li>
                <li>Cumplimiento de obligaciones legales.</li>
                <li>
                  Autoridades competentes cuando la ley así lo requiera.
                </li>
              </ul>
            </section>

            <section>
              <h3 className="text-2xl font-semibold mb-3">
                Derechos del usuario
              </h3>

              <p className="mb-3">
                Usted puede solicitar en cualquier momento:
              </p>

              <ul className="list-disc pl-6 space-y-2">
                <li>Acceder a sus datos.</li>
                <li>Corregir información.</li>
                <li>
                  Solicitar la eliminación de sus datos cuando sea legalmente
                  procedente.
                </li>
                <li>Limitar el uso de su información.</li>
              </ul>

              <p className="mt-3">
                Para ello puede escribirnos al correo de atención al cliente.
              </p>
            </section>

            <section>
              <h3 className="text-2xl font-semibold mb-3">
                Cambios
              </h3>

              <p>
                Happy Rental Cancún podrá actualizar este Aviso de Privacidad
                cuando sea necesario. La versión vigente siempre estará
                disponible en este sitio web.
              </p>
            </section>
          </div>
        </section>
      </main>

      <Footer />
      <WhatsAppButton />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/terminos-y-condiciones"
            element={<TermsAndConditions />}
          />
          <Route
            path="/aviso-de-privacidad"
            element={<PrivacyPolicy />}
          />
        </Routes>

        <Toaster position="top-center" />
      </div>
    </BrowserRouter>
  );
}

export default App;